import React from 'react';
import PropTypes from 'prop-types';

import { Form, FormControl, FormGroup } from 'react-bootstrap-5';
import { map } from 'lodash';

export default class FilterSelect extends React.Component {
  static propTypes = {
    ...FormControl.propTypes,
    defaultValue: PropTypes.any,
    label: PropTypes.string,
    options: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.any,
        value: PropTypes.any,
        label: PropTypes.any,
      })
    ),
  };

  render() {
    const { label } = this.props;
    return (
      <FormGroup className="d-flex flex-column gap-1 flex-fill">
        {this.renderLabel()}
        {this.renderSelect()}
      </FormGroup>
    );
  }

  renderLabel(label) {
    if (label) {
      return <Form.Label>{label}</Form.Label>;
    }
  }

  renderSelect() {
    const { label, options, placeholder, ...otherProps } = this.props;
    return (
      <Form.Select aria-label={label} placeholder={placeholder} {...otherProps}>
        {placeholder && this.renderDefaultOption(placeholder)}
        {this.renderOptions(options || [])}
      </Form.Select>
    );
  }

  renderOptions(options) {
    return map(options, (option, index) => (
      <option
        key={option.id ?? `__option__${index}-${option.value}`}
        value={option.value}
      >
        {option.label}
      </option>
    ));
  }

  renderDefaultOption(label) {
    return (
      <option key={`__default__${label}`} value={this.props.defaultValue}>
        {label}
      </option>
    );
  }
}
